<template>
  <div>
    <NuxtLayout
      name="asuostaticlayout"
      :title="$page?.sectionHero.title"
      :image-source="getUrl($page.sectionHero.image)"
      static-rfi-bg-color="#fff"
    >
      <SectionApollo
        class="mb-lg-space-xxl"
        :title="$page.sectionIntroduction.title"
        image-position="right"
        :image="getUrl($page.sectionIntroduction.image)"
      >
        {{ $page.sectionIntroduction.text }}
      </SectionApollo>
      <!-- section-questions -->
      <section
        class="section-bg rds-lazy py-space-lg py-md-space-xxl"
        data-background-image="https://cms.asuonline.asu.edu/sites/default/files/topo-pattern.jpg"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-10 offset-lg-1">
              <CardInfoHorizontal
                :bg-image-source="(getUrl($page.sectionQuestions.image) || undefined) as string"
                :image-fit="getUrl($page.sectionQuestions.image) ? 'cover' : 'contain'"
                :bg-image-alt="$page.sectionQuestions.imageAlt"
                image-position="left"
                :display-label="false"
                :display-highlight="false"
                :title="$page.sectionQuestions.title"
                title-level="h2"
                title-size="small"
                :cta-as-button="true"
                cta-button-variant="secondary"
                cta-text-variant="dark-3"
                cta-text-size="medium"
                cta-text-weight="bold"
                :cta-text="$page.sectionQuestions.ctaText"
                :cta-link="$page.sectionQuestions.ctaLink"
                @cta-click="handleQuestionsCtaClick($event)"
              >
                <div class="mb-space-sm mb-lg-space-md">
                  {{ $page.sectionQuestions.text }}
                </div>
              </CardInfoHorizontal>
            </div>
          </div>
        </div>
      </section>
      <section
        class="bg-light-2 pt-space-md pb-space-xxs pt-md-space-lg pb-md-space-sm py-lg-space-xxl"
      >
        <div class="container px-md-0">
          <div class="row">
            <div class="col-12">
              <h2 class="h2-medium mb-space-sm">
                {{ $page.sectionFinancialAid.title }}
              </h2>
              <div class="mb-space-lg" v-html="$page.sectionFinancialAid.text"></div>
            </div>
          </div>
          <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
            <div
              v-for="(card, index) in $page.sectionFinancialAid.cards"
              :key="index"
              class="col mb-space-sm mb-lg-0"
            >
              <CardIcon
                class="h-100"
                :icon-source="getUrl(card.icon)"
                :icon-alt="card.iconAlt"
                border-variant="light-4"
                :title="card.title"
                :cta-text="card.ctaText"
                :display-cta="true"
                :cta-link="card.ctaLink"
                cta-link-target="_blank"
                cta-text-weight="bold"
              />
            </div>
          </div>
        </div>
      </section>
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { analyticsComposable } from "@rds-vue-ui/analytics-gs-composable";
import { SectionApollo } from "@rds-vue-ui/section-apollo";
import $page from "~/assets/data/first-time-freshman-registration-rules.json";

const getUrl = (path: string) => {
  const assets = import.meta.glob("@/assets/img/first-time-freshman-registration-rules/**/*", {
    eager: true,
    import: "default"
  });
  const imgPath = assets["/assets/img/first-time-freshman-registration-rules/" + path];
  if (typeof imgPath !== "string") {
    return "";
  }
  return imgPath;
};
const siteUrl = useRuntimeConfig().public.siteUrl;

definePageMeta({
  layout: false,
  __dangerouslyDisableSanitizersByTagID: {
    "ldjson-schema": ["innerHTML"]
  },
  path: "/first-time-freshman-registration-rules"
});
useHead({
  title: $page.meta.title,
  meta: [
    { name: "Title", content: $page.meta.title },
    { name: "Description", content: $page.meta.description }
  ],
  link: [
    {
      rel: "canonical",
      href: useUtilityService().formatCanonicalUrl(`${siteUrl}${$page.path}`)
    }
  ],
  script: [useSchemaService().generateFirstTimeFreshmanRegistrationRulesSchema($page)]
});

const handleQuestionsCtaClick = (event: Event) => {
  event.preventDefault();
  analyticsComposable.trackLinkEvent(
    "internal link",
    "main content",
    $page.sectionQuestions.title.toLowerCase(),
    $page.sectionQuestions.ctaText.toLowerCase(),
    "card - info horizontal"
  );
  navigateTo($page.sectionQuestions.ctaLink, {
    open: {
      target: "_blank"
    }
  });
};
</script>

<style lang="scss" scoped>
.section-bg {
  background-size: auto;
  background-position: top;
  background-repeat: repeat;
}
:deep(.card-icon-height) {
  height: 47px;
}
</style>
